import { AuthenticationService } from './../services/authentication.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                location.reload(true);
            }
            else if (err.status === 404) {
                const error = 'API Endpoint Not Found!'
                return throwError(error);
            }
            else if (err.status === 500) {
                const error = 'Internal Server Error!'
                return throwError(error);
            }
            else if (!err.status) {
                const error = 'API not responding!'
                return throwError(error);
            }

            const error = err.error.message || 'Validation ERROR! Please Check your inputs.'
            return throwError(error);
        }));
    }
}
